// util/gtag.js
// Google Tag (GA4 + Google Ads) – Consent-Logik unverändert, aber:
// ✅ CONTACT_CONVERSION_LABEL gesetzt (aus deinem Google-Snippet)
// ✅ loadGoogleTag() ist awaitbar (Race-Condition-Fix)
// ✅ trackContactConversion() nutzt value/currency wie im Snippet + optional callback

const GA4_ID = "G-DZMFNEVQBG"; // dein GA4 / Google Analytics Tag
const ADS_ID = "AW-926242309"; // dein Google Ads Tag

// AUS GOOGLE ADS SNIPPET:
const CONTACT_CONVERSION_LABEL = "lbJICOeK1OcbEIWs1bkD";

function ensureDataLayer() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };
}

// --- CONSENT: unverändert ---
export function setConsentDefaultsDenied() {
  if (typeof window === "undefined") return;
  ensureDataLayer();

  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

export function updateConsent({ marketing, analytics }) {
  if (typeof window === "undefined") return;
  ensureDataLayer();

  window.gtag("consent", "update", {
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
    analytics_storage: analytics ? "granted" : "denied",
  });
}

// --- NEU: lädt EINMAL gtag.js und konfiguriert GA4 + Ads (awaitbar) ---
let loadPromise = null;

export function loadGoogleTag() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.__fit2clean_google_tag_loaded) return Promise.resolve();
  if (loadPromise) return loadPromise;

  ensureDataLayer();

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;

    // gtag.js nur einmal laden – GA4-ID reicht als Loader
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;

    script.onload = () => {
      window.gtag("js", new Date());

      window.gtag("config", GA4_ID, { anonymize_ip: true, send_page_view: false });

      window.gtag("config", ADS_ID, { anonymize_ip: true });

      window.__fit2clean_google_tag_loaded = true;
      resolve();
    };

    script.onerror = () => reject(new Error("Failed to load gtag.js"));
    document.head.appendChild(script);
  });

  return loadPromise;
}

export function trackContactConversion() {
  if (typeof window === "undefined") return Promise.resolve();
  ensureDataLayer();

  return new Promise((resolve) => {
    window.gtag("event", "conversion", {
      send_to: `${ADS_ID}/${CONTACT_CONVERSION_LABEL}`,
      value: 1.0,
      currency: "EUR",
      event_callback: resolve,
      event_timeout: 2000,
    });

    // Fallback, falls event_callback nicht feuert
    setTimeout(resolve, 2200);
  });
}
